import Analytics from '@components/charts/analytics/Analytics'
import SpendPerDay from '@components/charts/venue/SpendPerDay'
import SpendPerPartySize from '@components/charts/venue/SpendPerPartySize'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Col, Row, Space } from 'antd'
import { Dayjs } from 'dayjs'

interface Props {}

const RevenueSpendsSection = ({}: Props) => {
  const venue = useAppSelector(selectSelectedVenue())

  if (!venue) return <></>

  return (
    <Space orientation="vertical" className="w-full" size={16}>
      <PageTitle
        level={5}
        title={'Revenue & spends'}
        style={{ margin: 0 }}
        toolbar={
          <Space>
            <Analytics.Product />
            <Analytics.Date
              rangePresets={Analytics.rangesPresets.venue}
              defaultValue={
                Analytics.rangesPresets.venue![0].value as [Dayjs, Dayjs]
              }
            />
          </Space>
        }
      />
      <Analytics.RowStatistics
        entity="venue"
        entityId={venue.id}
        kind="venue-app-revenue"
      />
      <Row gutter={[16, 16]}>
        <Col span={10}>
          <SpendPerDay />
        </Col>
        <Col span={14}>
          <SpendPerPartySize />
        </Col>
      </Row>
    </Space>
  )
}

export default RevenueSpendsSection
